import React from 'react';
import { Pagination as BootstrapPagination } from 'react-bootstrap';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPagesToShow = 5; // Adjust this number to show more or less page numbers
    let startPage, endPage;

    if (totalPages <= maxPagesToShow) {
      // Show all pages
      startPage = 1;
      endPage = totalPages;
    } else {
      // Logic to show a limited number of pages
      const maxPagesBeforeCurrent = Math.floor(maxPagesToShow / 2);
      const maxPagesAfterCurrent = Math.ceil(maxPagesToShow / 2) - 1;

      if (currentPage <= maxPagesBeforeCurrent) {
        startPage = 1;
        endPage = maxPagesToShow;
      } else if (currentPage + maxPagesAfterCurrent >= totalPages) {
        startPage = totalPages - maxPagesToShow + 1;
        endPage = totalPages;
      } else {
        startPage = currentPage - maxPagesBeforeCurrent;
        endPage = currentPage + maxPagesAfterCurrent;
      }
    }

    // Add page numbers
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <BootstrapPagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </BootstrapPagination.Item>
      );
    }

    // Add ellipsis and first/last page links if necessary
    if (startPage > 1) {
        pageNumbers.unshift(<BootstrapPagination.Ellipsis key="start-ellipsis" disabled />);
    }
    if (endPage < totalPages) {
        pageNumbers.push(<BootstrapPagination.Ellipsis key="end-ellipsis" disabled />);
    }

    return pageNumbers;
  };

  if (totalPages <= 1) {
    return null; // Don't render pagination if there's only one page
  }

  return (
    <BootstrapPagination>
      <BootstrapPagination.First
        onClick={() => handlePageChange(1)}
        disabled={currentPage === 1}
      />
      <BootstrapPagination.Prev
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      />
      {renderPageNumbers()}
      <BootstrapPagination.Next
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage >= totalPages}
      />
      <BootstrapPagination.Last
        onClick={() => handlePageChange(totalPages)}
        disabled={currentPage >= totalPages}
      />
    </BootstrapPagination>
  );
};

export default Pagination;
